
import {useEffect, useState} from "react";
import AceEditor from "react-ace";

function BodyTabEditor(props) {

    useEffect(() => {

    }, []);

    return (
        <div className="editor">
            <AceEditor
                readOnly={true}
                mode="json"
                theme="dracula"
                value={JSON.stringify(props.body, null, 2)}
                height='300px'
            ></AceEditor>
        </div>
    );
}

export default BodyTabEditor;
